import React from "react";
import { Zap, Table2, Sigma, ListChecks } from "lucide-react";
import { Blocks } from "./Blocks";

const ICON = { card: Zap, table: Table2, formula: Sigma, skills: ListChecks };

export default function SummaryView({ course }) {
  return (
    <div>
      <div className="section-head">
        <span className="eyebrow">{course.code} · Hap Bilgiler</span>
        <h1 className="page-title">Sınav Öncesi Hap Bilgiler</h1>
        <p className="page-sub">Tam sunum özetleri, karşılaştırma tabloları ve formül kartları — sınavdan önceki son 15 dakika için.</p>
      </div>
      <div className="summary-grid" data-testid="summary-grid">
        {course.summary.map((s, i) => {
          const Icon = ICON[s.kind] || Zap;
          return (
            <div key={i} className={`sum-card sum-${s.kind}`} data-testid={`summary-card-${i}`}>
              <div className="sum-head">
                <span className="sum-icon"><Icon size={15} /></span>
                <h3>{s.h}</h3>
              </div>
              <Blocks blocks={s.blocks} />
            </div>
          );
        })}
      </div>
    </div>
  );
}
